import { css } from '@emotion/react'

export const visibilityIcon = css`
  cursor: default;
`

export * from '../../styles'
